import { createI18n } from 'vue-i18n'

function loadLocaleMessages() {
  const locales = import.meta.glob('./*/**.json', { eager: true })
  const messages = {}

  for (const path in locales) {
    const match = path.match(/\.\/([a-z]{2})\/(.+)\.json$/)
    if (match) {
      const [, locale, file] = match
      if (!messages[locale]) {
        messages[locale] = {}
      }
      messages[locale][file] = locales[path].default
    }
  }

  return messages
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
})

export default i18n
